
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/industries/retail",
      function () {
        return require("private-next-pages/solutions/industries/retail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/industries/retail"])
      });
    }
  